import { Component, OnInit, Input } from '@angular/core';
import { AdaCustomization } from 'core/models/ada-customization';

@Component({
  selector: 'lms-customizations-list-detail',
  templateUrl: './customizations-list-detail.component.html',
  styleUrls: ['./customizations-list-detail.component.scss']
})
export class CustomizationsListDetailComponent implements OnInit {
  @Input() customization: AdaCustomization;

  constructor() {}

  ngOnInit() {}
}
